import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../AuthContext';
import './LoginPage.css';

const LoginPage = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    const result = await login(email);
    if (result.success) {
      navigate(`/members/check-email?email=${encodeURIComponent(email)}`);
    } else {
      setError(result.error || 'Impossible d\'envoyer le lien');
    }

    setLoading(false);
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-logo">
          <svg width="60" height="60" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="20" cy="20" r="18" fill="#1f5d5b" stroke="#1f5d5b" strokeWidth="2" />
            <text x="20" y="26" textAnchor="middle" fill="white" fontSize="16" fontWeight="bold" fontFamily="'Lucidity Condensed', cursive">T</text>
          </svg>
        </div>

        <h1 className="login-title">Espace Membres</h1>
        <p className="login-subtitle">Accédez au contenu exclusif réservé aux membres The Recap</p>

        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-group">
            <input
              type="email"
              placeholder="Votre adresse email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="email-input"
            />
          </div>

          {error && <div className="error-message">{error}</div>}

          <button type="submit" className="send-button" disabled={loading}>
            {loading ? 'Envoi en cours...' : 'Recevoir mon lien de connexion'}
          </button>
        </form>

        <p className="access-note">Accès réservé aux membres The Recap.</p>

        <Link to="/" className="back-link">Retour au site</Link>
      </div>
    </div>
  );
};

export default LoginPage;
